import { Helmet } from 'react-helmet-async';
import Header from '../components/homepage/Header';
import HeroBlock from '../components/homepage/HeroBlock';
import SensorSection from '../components/homepage/SensorSection';
import SolutionsSection from '../components/homepage/SolutionsSection';
import AboutSection from '../components/homepage/AboutSection';
import GetAppSection from '../components/homepage/GetAppSection';
import Footer from '../components/homepage/Footer';

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title> Video Plus Sensors </title>
      </Helmet>
      <Header />
      <HeroBlock />
      <SolutionsSection />
      <SensorSection />
      <AboutSection />
      <GetAppSection />
      <Footer />
    </>
  );
}
